
import { LitElement, html, unsafeCSS } from "lit-element"
import Ripple from "../ripple"
import style from "./icon.css"
import fa from "../../font/fontawesome/css/all.min.css"

export default class extends LitElement {
	static styles = [unsafeCSS(style), unsafeCSS(fa)]
	static get properties () {
		return {
			icon: { type: String }, // 利用しないこと. icon属性は実際に存在し、deprecatedされているためバンドラに削除されうる.
			iconName: { type: String, attribute: "icon-name" },
			ripple: { type: Boolean }
		}
	}

	/** @type {Ripple} */
	#ripple

	constructor () {
		super()
		this.icon = ""
		this.iconName = ""
		this.ripple = false
	}

	set ripple (value) {
		if (value) {
			this.#ripple = new Ripple(this, { center: true })
			this.#ripple.init()
		} else {
			if (this.#ripple) this.#ripple.destroy()
			this.#ripple = null
		}
	}

	get ripple () {
		return !!this.#ripple
	}

	get actualIcon () {
		return this.iconName || this.icon
	}

	render () {
		return html`
			<i class="${this.actualIcon}">
				<slot></slot>
			</i>
		`
	}
}
